module.exports = __webpack_public_path__ + "static/media/sip_date_icon.d54e0664.svg";